var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-wrap-plus gray-30-bg"},[_c('div',{staticClass:"switch"},_vm._l((_vm.switchOptions),function(item,index){return _c('span',{key:index,class:_vm.sel === item.value ? "circleChecked blue-bg white-cl" : "circleCheckOut gray-cl",on:{"click":function($event){return _vm.toggle(item)}}},[_vm._v(_vm._s(item.label))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }